import { hrService } from "../../../../../Api/Services/HRService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

// Async thunk to send probation reminder mail to manager
export const sendProbationReminderMail = createServiceAsyncThunk<
  { success: boolean; message: string },
  { user_id: number }
>(
  ACTION_NAMES.SEND_PROBATION_REMINDER_MAIL,
  ({ user_id }) => hrService.sendProbationReminderMail(user_id),
  ERROR_MESSAGES.SEND_PROBATION_REMINDER_MAIL_FAILURE
);

// Slice for probation reminder mail action
const probationReminderMailerSlice = createGenericSlice<
  { success: boolean; message: string },
  any
>(SLICE_NAMES.PROBATION_REMINDER_MAILER_SLICE, sendProbationReminderMail);

// Export actions
export const {
  clearError: clearProbationReminderMailError,
  clearSuccessMessage: clearProbationReminderMailSuccess,
} = probationReminderMailerSlice.actions;

export default probationReminderMailerSlice.reducer;
